import { useCallback } from "react";
import { ProductsApi, useAPIAction } from "melco-shared-logic";
import { EditProductFormValueInterface } from "../../components/products/form/EditProductForm";

export const useEditProduct = () => {
  const [editProduct] = useAPIAction(
    ProductsApi,
    async (api, ProductDetails: EditProductFormValueInterface) => {
      const payload = {
        productCode: ProductDetails.code,
        identityMelcoModelsUpdateProduct: {
          name: ProductDetails.name,
          app_startup_endpoint: ProductDetails.app_startup_endpoint,
          description: ProductDetails.description,
          devices_allowed: ProductDetails.devices_allowed,
          max_devices_allowed: ProductDetails.max_devices_allowed,
          offline_seconds_allowed: ProductDetails.offline_seconds_allowed,
          seconds_to_relogin: ProductDetails.seconds_to_relogin,
          //       legal_policy_version: ProductDetails.legal_policy_version
        },
      };

      const data = await api.productsEditProduct(payload);

      return {
        successMessages: [{ message: "default" }],
        data,
      };
    },
    {
      translationPrefix: "products_list.edit.drawer.actions.update",
    }
  );

  return useCallback(
    async (productDetails: EditProductFormValueInterface) => {
      try {
        await editProduct(productDetails);
      } catch (e) {
        return { success: false };
      }

      return { success: true };
    },
    [editProduct]
  );
};
